import { builder } from '@builder.io/sdk';
import builderConfig from '../../builder-config';
import { builderModels } from './builderPage';
import { selectCurrentPencilEntry } from './usePromoCountdown';

const apiKey = builderConfig?.builderAPIKey;

builder.init(apiKey);

// Picks the entry that currently owns the pencil banner: the first in list
// order (createdDate desc, matching the build-time GraphQL query) that is
// live, falling back to an evergreen entry or the most-recent-started one
// so the banner slot never goes blank. A scheduled entry whose startDate
// hasn't passed can't preempt the current one — see selectCurrentPencilEntry.
// noTargeting returns scheduled and expired entries too, as the build's
// GraphQL query does, so the schedule is applied here instead of being
// short-circuited by Builder's server clock.
export async function fetchPromotionsBannerData() {
    const entries = await builder.getAll(builderModels.promotionsBanners, {
        limit: 10,
        sort: { createdDate: -1 },
        options: { published: 'published', noTargeting: true },
    });

    return selectCurrentPencilEntry(entries, Date.now());
}
